import React, { useEffect, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap';
import { cancelAttendance } from '../../api/attendance';

const CancelAttendanceModal = ({
  modalOpenState,
  closeModalHandler,
  attendanceId,
  fetchNewData
}) => {
  const [successAlert, setSuccessAlert] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });

  function showErrorAlert(message) {
    setRequestError({ message, show_alert: true });
  }

  function resetErrorAlert() {
    setRequestError({ message: '', show_alert: false });
  }

  const cancelAttendanceRequest = async () => {
    resetErrorAlert();
    setRequestLoading(true);

    const { response, error } = await cancelAttendance(attendanceId);

    if (response) {
      setRequestLoading(false);
      setSuccessAlert('Attendance cancelled successfully');
      fetchNewData();
      closeModalHandler();
    }

    if (error) {
      setRequestLoading(false);
      showErrorAlert(error);
    }
  };

  useEffect(() => {
    resetErrorAlert();
  }, [modalOpenState]);

  return (
    <React.Fragment>
      {successAlert && (
        <SweetAlert
          success
          title="Cancel Requested"
          onConfirm={() => setSuccessAlert(false)}
        >
          {successAlert}
        </SweetAlert>
      )}

      <Modal isOpen={modalOpenState} backdrop="static" size="md">
        <ModalHeader toggle={closeModalHandler}>Cancel Attendance</ModalHeader>
        <ModalBody>
          {requestError.show_alert && (
            <Alert
              color="danger"
              role="alert"
              isOpen={requestError.show_alert}
              toggle={resetErrorAlert}
            >
              <i className="mdi mdi-block-helper mr-2"></i>
              {requestError.message}
            </Alert>
          )}
          <h4>Are you sure you want to cancel this approved request?</h4>
        </ModalBody>
        <ModalFooter>
          <Button
            disabled={requestLoading}
            type="button"
            color="light"
            onClick={closeModalHandler}
          >
            Close
          </Button>
          <Button
            type="button"
            color="warning"
            disabled={requestLoading}
            onClick={cancelAttendanceRequest}
          >
            {requestLoading ? 'Cancelling...' : 'Cancel Request'}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default CancelAttendanceModal;
